import UploadProgressComponent from "../Reusable/UploadProgressComponent.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { UploaderFilesButtons } from "./UploaderFilesButtons/UploaderFilesButtons.tsx";
import ExpiresAfterElement from "../Reusable/ExpiresAfter/ExpiresAfterElement.tsx";

export const UploaderFooter = () => {
  const { uploaderGetFiles } = useUploader();

  return uploaderGetFiles().length !== 0 ? (
    <div className="home-upload-content-footer">
      <UploadProgressComponent />
      <UploaderFilesButtons />
      <ExpiresAfterElement />
    </div>
  ) : null;
};
